// extracted by mini-css-extract-plugin
export default {"button-style":"ButtonStyle_button-style__gmACX"};